import { useRouteSelection } from "../hooks/useRouteSelection";
import { useMapController } from "../features/map/controllers/useMapController";
import { useVillageController } from "../features/village/controllers/useVillageController";
import { useIntervieweeController } from "../features/interviewee/controllers/useIntervieweeController";

export function useAppViewModel() {
  const routeSelection = useRouteSelection();
  const mapController = useMapController(routeSelection);
  const villageController = useVillageController({
    routeSelection,
    reference: mapController.reference,
    selectedVillageRecord: mapController.selectedVillageRecord,
    selectedVillageBackendRef: mapController.selectedVillageBackendRef,
  });
  const intervieweeController = useIntervieweeController({
    routeSelection,
    interviewees: villageController.interviewees,
  });
  return {
    route: {
      viewRef: routeSelection.viewRef,
      setViewRef: routeSelection.setViewRef,
    },
    status: mapController.status,
    mapVillages: mapController.mapVillages,
    previewVillages: mapController.previewVillages,
    selectedVillage: villageController.selectedVillage,
    selectedVillageRef: mapController.selectedVillageRef,
    selectedInterviewee: intervieweeController.selectedInterviewee,
    intervieweeDetail: intervieweeController.intervieweeDetail,
    intervieweeMediaPreviews: intervieweeController.mediaPreviews,
    interviewees: villageController.interviewees,
    evidenceItems: villageController.evidenceItems,
    loading: {
      village: villageController.loading,
      interviewee: intervieweeController.loading,
    },
    summaryLines: villageController.summaryLines,
    villageFacts: villageController.villageFacts,
    intervieweeDirectorySummary: villageController.intervieweeDirectorySummary,
    evidenceOverviewLines: villageController.evidenceOverviewLines,
    incidentEntries: villageController.incidentEntries,
    incidentOverview: villageController.incidentOverview,
    evidenceEntries: villageController.evidenceEntries,
    pagination: villageController.pagination,
    handlers: {
      selectVillage: mapController.handlers.selectVillage,
      selectInterviewee: villageController.handlers.selectInterviewee,
      clearInterviewee: () => routeSelection.setIntervieweeRef(null),
      loadMoreInterviewees: villageController.handlers.loadMoreInterviewees,
      toggleIncidentOverview: villageController.handlers.toggleIncidentOverview,
    },
  };
}